import React from 'react'
import PropTypes from 'prop-types'

import { ScreenHeader } from '../../../../../../components/generic'
import { groupChartData } from '../../EMARChart/utils'
import { EMARScreenEmptyState } from '../../components'
import MARChart from '../../EMARChart/EMARChart'

export default function EMARResidentPDF(props) {
  const { chartData = [], endDate, resident, residentName, startDate } = props

  if (!chartData.length) return <EMARScreenEmptyState resident={resident} />

  const groups = groupChartData(chartData)

  return (
    <div style={styles.pdfWrapper}>
      {groups.map((group) => (
        <div key={group[0].id} className="page-break-after">
          <ScreenHeader title={`${residentName}'s eMar`} />
          <MARChart
            displayTableHeader={false}
            isPDF
            startDate={startDate}
            endDate={endDate}
            medications={group}
            rowDisplaySettings={{
              isMedLinkActive: true,
            }}
          />
        </div>
      ))}
    </div>
  )
}

EMARResidentPDF.propTypes = {
  chartData: PropTypes.array.isRequired,
  endDate: PropTypes.object.isRequired,
  resident: PropTypes.object.isRequired,
  residentName: PropTypes.string.isRequired,
  startDate: PropTypes.object.isRequired,
}

const styles = {
  pdfWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 1190,
    // height: '100vh',
    // maxWidth: '100vw',
    minHeight: 1480,
    zIndex: 1000,
    background: 'white',
    padding: '24px 28px',
  },
}
